document.addEventListener("DOMContentLoaded", () => {
    const questions = document.querySelectorAll(".faq-question");

    questions.forEach((q) => {
      q.addEventListener("click", () => {
        const answer = q.nextElementSibling;
        const plusIcon = q.querySelector(".icon-plus");
        const minusIcon = q.querySelector(".icon-minus");

        // Close all other open answers before toggling this one
        questions.forEach((otherQ) => {
          if (otherQ !== q) {
            const otherAnswer = otherQ.nextElementSibling;
            const otherPlusIcon = otherQ.querySelector(".icon-plus");
            const otherMinusIcon = otherQ.querySelector(".icon-minus");

            otherAnswer.style.maxHeight = null;
            otherAnswer.style.opacity = 0;
            otherAnswer.classList.remove("open");
            otherQ.classList.remove("active");
            otherPlusIcon.classList.remove("hidden");
            otherMinusIcon.classList.add("hidden");
          }
        });

        // Toggle the clicked FAQ
        q.classList.toggle("active");

        if (answer.classList.contains("open")) {
          answer.style.maxHeight = null;
          answer.style.opacity = 0;
          answer.classList.remove("open");
          plusIcon.classList.remove("hidden");
          minusIcon.classList.add("hidden");
        } else {
          answer.style.maxHeight = answer.scrollHeight + "px";
          answer.style.opacity = 1;
          answer.classList.add("open");
          plusIcon.classList.add("hidden");
          minusIcon.classList.remove("hidden");
        }
      });
    });
  });
